import React from 'react';
import { QueryDrilldownDialog, QueryDrilldownDialogProps } from './QueryDrilldownDialog';
import { useDashboard } from "routes/dashboard/Dashboard";

export function DashboardQueryDrilldownDialog(props: QueryDrilldownDialogProps) {
  const dashboard = useDashboard();

  return (
    <QueryDrilldownDialog
      {...props}
      hideDashboardDrilldown={false}
      defaultDrilldownDashboardId={dashboard?.id}
    />
  );
}